import { Typography as TypographyMUI, TypographyProps as TypographyPropsMUI } from '@mui/material';

export type TypographyProps = TypographyPropsMUI;
export const Typography = TypographyMUI;
